import React from "react";
import styled from "styled-components";

const StyledBlockquote = styled.blockquote`
  font-size: ${({ $large }) => ($large ? "44px" : "30px")};
  line-height: ${({ $large }) => ($large ? "44px" : "33px")};
  color: ${({ theme, $colour = "grey" }) => theme.colours[$colour]};

  p {
    text-indent: -23px;
  }

  p::before {
    content: "\\201C";
    line-height: 0;
    position: relative;
    left: -10px;
    top: 30px;
    font-size: ${({ $large }) => ($large ? "90px" : "70px")};
    color: ${({ theme }) => theme.colours.blue};
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints[1]}px`}) {
    font-size: 28px;
    line-height: 33px;
    p::before {
      font-size: 70px;
    }
  }
`;

function Blockquote({ children, colour, large, ...others }) {
  return (
    <StyledBlockquote
      $large={large}
      $colour={colour}
      dangerouslySetInnerHTML={{ __html: children?.childMarkdownRemark?.html }}
      {...others}
    />
  );
}

export default Blockquote;
